<template>
  <layout-basic>
    <page-hero
      title="Management Development"
      lead="Develop managers who build stronger teams."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Build stronger managers and leaders"
      :points="points"
      :columns="2"
      tint
    />

    <standard-cta
      title="Ready to develop your managers?"
      lead="Explore Leadership Plus, watch the 4-minute demo, or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionManagement',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Management Development | IMPROVE',
      description:
        'Develop managers who build stronger teams with practical leadership programmes on IMPROVE.',
      path: '/solutions/management-development',
    });
  },
  data() {
    return {
      points: [
        'Practical programmes for aspiring managers',
        'Support for first-line managers',
        'Development for senior managers and directors',
        'Optional ILM-aligned pathways via Leadership Plus',
        'Combine management learning with day-to-day training',
        'One platform for employees and leaders',
      ],
    };
  },
};
</script>
